<template>
  <div class="row m-0">
    <div v-for="(item, shipment) in summaries" class="col-12 row bg-light mb-4 mr-0 ml-0 p-0 manifest" :key="shipment.id">
      <div class="col-md-4 col-sm-12 bg-dark text-light p-3">
        <p class="h6 text-secondary">
          Shipment
          <span class="pull-right pr-3">
            <p class="h6 text-secondary">
              Completion
            </p>
            <p class="h5 mb-4">
              <span class="text-light">{{ Math.floor(item.total_percentage) }}%</span>
            </p>
          </span>
        </p>
        <p class="h5 mb-4"><router-link :to="`/shipment_md/shipments/${item.id}`" class="text-light">No. {{ item.number }}</router-link></p>
        <b-collapse :id="`shipment--detail--${shipment}`">
          <p class="h6 text-secondary">Company</p>
          <p class="h6 mb-5">{{ get(item, 'company.name') }}</p>
        </b-collapse>
        <div class="mx-auto col-2">
          <div ref="collapse" class="control-button bg-light text-center p-3 control-bottom"
            v-b-toggle="`shipment--detail--${shipment}`"
            @click="showDetail(shipment)"
            title="Show Shipment Detail"
            style="cursor: pointer;">
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-12 bg-light p-0" style="z-index: 0;">
        <div class="row m-0 p-0 journey__container">
          <div @click="moveLeft(shipment)" class="control-button bg-light col-md-1 col-2 text-center control-left"
            style=""></div>
          <div class="col-md-10 col-8 text-center row m-0 p-0">
            <div class="journey col-12 align-items-center d-flex flex-row flex-nowrap" ref="journey">
              <div v-for="(job, bar) in item.destinations" :id="'job' + bar" class="journey__job"
                v-if="item.destinations[bar].percentage !== undefined"
                :class="{
                  'journey--pending':
                    item.destinations[bar].percentage === 0 &&
                    (bar !== 0 && item.destinations[bar - 1].percentage < 100) ||
                    (bar !== 0 && item.destinations[bar - 1].percentage < 100),
                  'journey--progress show-marker':
                    item.destinations[bar].percentage >= 0 &&
                    item.destinations[bar].percentage < 100 &&
                    ((bar !== 0 && item.destinations[bar - 1].percentage === 100) || bar === 0),
                  'journey--complete':
                    !checkLastComplete(bar, item.destinations) &&
                    item.destinations[bar].percentage === 100,
                  'last--complete':
                    checkLastComplete(bar, item.destinations) &&
                    item.destinations[bar].percentage === 100,
                }"
                :style="'width :' + calculateBarWidth(shipment, bar) + '%;'" :key="job.id">
                <div :ref="`journey__bar--${shipment}${bar}`" class="journey__bar" :style="{ width: item.destinations[bar].percentage + '%' }">
                  <div class="journey__marker" :id="`journey__marker${shipment}${bar}`" tabindex="0"></div>
                  <b-popover placement="bottom" :target="`journey__marker${shipment}${bar}`" triggers="hover">
                    Click To See Latest Position
                  </b-popover>
                  <b-popover placement="bottom" :target="`journey__marker${shipment}${bar}`" triggers="focus">
                    <template slot="title">Latest Position</template>
                    <ul class="list-group list-group-flush list-group--full p-2">
                      <li class="list-group-item p-1 pt-2 pb-2">
                        Address : <strong>{{ get(item.vehicle, 'gps_devices.0.gps_info.road_name') }}</strong>
                      </li>
                      <li class="list-group-item p-1 pt-2 pb-2">
                        Latitude : <strong>{{ get(item.vehicle, 'gps_devices.0.gps_info.latitude') }}</strong>
                      </li>
                      <li class="list-group-item p-1 pt-2 pb-2">
                        Longitude : <strong>{{ get(item.vehicle, 'gps_devices.0.gps_info.longitude') }}</strong>
                      </li>
                    </ul>
                  </b-popover>
                  <div class="journey__percentage" tabindex="0">
                    <b-badge pill variant="warning">{{ (item.destinations[bar] || {}).percentage }}%</b-badge>
                  </div>
                  <div class="journey__percentage--bottom" tabindex="1">
                    <b-badge pill variant="success">{{ Math.floor(summaries[shipment].total_percentage) }}%</b-badge>
                  </div>
                </div>
                <div class="dot dot--first" :id="`dot--first--${shipment}${bar}`" v-if="bar === 0" tabindex="0"></div>
                <b-popover placement="bottom" :target="`dot--first--${shipment}${bar}`" triggers="hover focus">
                  <template slot="title">Origin</template>
                  <ul class="list-group list-group-flush list-group--full p-2">
                    <li class="list-group-item p-1 pt-2 pb-2">
                      Code : <strong>{{ item.origin.code }}</strong>
                    </li>
                    <li class="list-group-item p-1 pt-2 pb-2">
                      Name : <strong>{{ item.origin.name }}</strong>
                    </li>
                    <li class="list-group-item p-1 pt-2 pb-2">
                      Address : <strong>{{ get(item, 'origin.metadata.info.address') }}</strong>
                    </li>
                  </ul>
                </b-popover>
                <div class="dot dot--last" :id="`dot--last--${shipment}${bar}`" tabindex="0"></div>
                <b-popover placement="bottom" :target="`dot--last--${shipment}${bar}`" triggers="hover">
                  Click To See Job Detail
                </b-popover>
                <b-popover placement="bottom" :target="`dot--last--${shipment}${bar}`" triggers="focus">
                  <template slot="title">Job Detail - {{ calculateJobCompleted(job.orders) }} of {{ job.orders.length }} Completed</template>
                  <b-card no-body class="text-center mb-3 p-2">
                    {{ get(job, 'orders[0].customer.name') }}<br>{{ job.address }}
                  </b-card>
                  <b-tabs>
                    <b-tab
                      v-for="(piece, pieceNum) in job.orders"
                      :title="(pieceNum + 1).toString()"
                      :key="piece.id"
                      :title-link-class="linkClass(piece.status)">
                      <ul class="list-group list-group-flush list-group--full">
                        <li class="list-group-item p-1 pt-2 pb-2">
                          Order Number : <strong>{{ piece.number }}</strong>
                        </li>
                        <li class="list-group-item p-1 pt-2 pb-2">
                          Status : <strong>{{ piece.status }}</strong>
                        </li>
                        <li class="list-group-item p-1 pt-2 pb-2">
                          <div class="text-center"><strong>Units</strong></div>
                          <hr class="m-1">
                          <div style="max-height: 100px; overflow-y: auto; overflow-x: hidden;">
                            <ul class="list-group list-group-flush">
                              <li v-for="unit in piece.units" class="list-group-item units__container" :key="unit.number">
                                {{ unit.number }} - {{ unit.type }}
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </b-tab>
                  </b-tabs>
                </b-popover>
              </div>
            </div>
          </div>
          <div @click="moveRight(shipment)" class="control-button bg-light col-md-1 col-2 text-center control-right"
          style=""></div>
        </div>
        <b-collapse :id="`shipment--detail--${shipment}`">
          <div class="row m-0 p-3 border border-right-0 border-left-0 border-bottom-0">
            <div class="col-6 border border-top-0 border-bottom-0 border-left-0">
              <p class="h6 text-muted">Truck</p>
              <p class="h6 mb-1">{{ get(item, 'vehicle.reg_no') }}</p>
              <p class="text-secondary mb-0">{{ get(item, 'vehicle.company.name') }}</p>
            </div>
            <div class="col-6">
              <p class="h6 text-muted">Driver</p>
              <p class="h6 mb-0">{{ get(item, 'driver.name') }}</p>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { remove, get, isEmpty } from 'lodash';

export default {
  name: 'completion-item',
  props: [
    'summaries',
  ],
  data() {
    return {
      transform: 0,
      shipment: [
        {
          numBar: 1,
          widthBar: 0,
        },
      ],
      detail: {
        shipment: [],
      },
    };
  },
  methods: {
    get(object, key) {
      return get(object, key) || '';
    },
    checkLastComplete(i, dt) {
      let isLast = false;
      if (!isEmpty(dt)) { isLast = i === dt.length - 1; }
      return isLast;
    },
    formatAddress(address) {
      let { address1, address2 } = address;

      address1 = address1 !== null ? address1 : '';
      address2 = address2 !== null ? address2 : '';

      return `${address1} ${address2}`;
    },
    formatControlClass(shipment) {
      const exist = this.detail.shipment.find(comparasion => comparasion === shipment);
      return exist;
    },
    calculateBarWidth(shipment, bar) {
      if (this.shipment[shipment] === undefined) {
        this.shipment[shipment] = {
          numBar: 1,
        };
      }

      if (bar + 1 > this.shipment[shipment].numBar) {
        this.shipment[shipment].numBar = bar + 1;
      }

      return 100 / this.shipment[shipment].numBar;
    },
    moveRight(shipment) {
      const journey = this.$refs.journey[shipment];
      const child = journey.childNodes;
      const length = child[0].offsetWidth * Object.keys(child).length;

      if (length - (journey.offsetWidth - 30) > 1) {
        if ((length - (journey.offsetWidth - 30)) + this.transform > 190) {
          this.transform -= 190;
        } else {
          this.transform -= (length - (journey.offsetWidth - 30)) + this.transform;
        }
      }

      /* eslint-disable array-callback-return */
      Object.keys(child).map((index) => {
        if (child[index].style.transform !== undefined &&
            child[index].style.transform !== null &&
            child[index].style.transform > 0) {
          this.transform = parseInt(child[index].style.transform.split('(')[1].split('px')[0], 10);
        }

        child[index].style.transform = `translate(${this.transform}px,0)`;
      });
    },
    moveLeft(shipment) {
      const journey = this.$refs.journey[shipment];
      const child = journey.childNodes;

      if (this.transform < -1) {
        if (this.transform < -190) {
          this.transform += 190;
        } else {
          this.transform -= this.transform;
        }
      }

      /* eslint-disable array-callback-return */
      Object.keys(child).map((index) => {
        if (child[index].style.transform !== undefined &&
            child[index].style.transform !== null &&
            child[index].style.transform > 0) {
          /* eslint-disable radix */
          this.transform = parseInt(child[index].style.transform.split('(')[1].split('px')[0]);
        }

        child[index].style.transform = `translate(${this.transform}px,0)`;
      });
    },
    showDetail(shipment) {
      const exist = this.detail.shipment.find(comparasion => comparasion === shipment);

      if (exist === undefined) {
        this.$refs.collapse[shipment].title = 'Hide Shipment Detail';
        this.$refs.collapse[shipment].classList.add('control-top');
        this.$refs.collapse[shipment].classList.remove('control-bottom');
        this.detail.shipment.push(shipment);
      } else {
        this.$refs.collapse[shipment].title = 'Show Shipment Detail';
        this.$refs.collapse[shipment].classList.remove('control-top');
        this.$refs.collapse[shipment].classList.add('control-bottom');
        remove(this.detail.shipment, n => n === exist);
      }
    },
    calculateJobCompleted(item) {
      let confirmed = 0;
      item.map((order) => {
        if (order.status === 'CONFIRMED') {
          confirmed += 1;
        }
      });
      return confirmed;
    },
    linkClass(status) {
      if (status === 'CONFIRMED') {
        return ['bg-success', 'text-light'];
      }

      return ['bg-white', 'text-dark'];
    },
  },
};
</script>
<style lang="sass">
.control-button
  background-size: 50%
  background-repeat: no-repeat
  background-position: center

.control-left
  cursor: pointer
  background-image: url('../../../../../assets/ui/left-arrow.png')

.control-right
  cursor: pointer
  background-image: url('../../../../../assets/ui/right-arrow.png')

.control-top
  background-image: url('../../../../../assets/ui/top-arrow.png')

.control-bottom
  background-image: url('../../../../../assets/ui/bottom-arrow.png')

.journey
  overflow: hidden

.journey__container
  height: 133px

.journey__job
  position: relative
  min-width: 135px
  transition: transform .5s ease-in-out
  z-index: 1
  background-color: #868e96

  &.journey--progress
    background-color: #BDBDBD

    .journey__bar
      border-color: #28a745

    .journey__marker
      display: block

    .journey__percentage
      display: block

    .journey__percentage--bottom
      display: block

  &.journey--complete
    background-color: #28a745

    .journey__bar
      border-color: #28a745

  &.journey--pending
    background-color: #BDBDBD

    .journey__bar
      border-color: #BDBDBD

  &.last--complete
    background-color: #28a745

    .journey__bar
      border-color: #28a745

    .journey__marker
      display: block

    .journey__percentage
      display: block

.journey__bar
  position: relative
  border-width: 3px 0 3px 0
  border-style: solid
  border-color: #333

  &:first-child
    min-width: 20px

.journey__marker
  display: none
  position: absolute
  width: 30px
  height: 30px
  background-size: contain
  background-repeat: no-repeat
  background-position: center
  background-image: url('../../../../../assets/ui/truck.png')
  margin-top: -25px
  z-index: 4
  right: 0
  cursor: pointer

.journey__percentage
  display: none
  position: absolute
  margin-top: -40px
  z-index: 4
  right: 0

.journey__percentage--bottom
  display: none
  position: absolute
  margin-top: 10px
  z-index: 4
  right: 0

.dot
  position: absolute
  width: 40px
  height: 40px
  background-size: contain
  background-repeat: no-repeat
  background-position: center
  background-image: url('../../../../../assets/ui/marker.png')
  margin: -36px -9px 0 -9px
  z-index: 3

  &.dot--first
    left: 0

  &.dot--last
    right: 0
    cursor: pointer

.units__container
  padding: 5px
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/completion/Item.vue